import React, { useState, useEffect, useRef } from 'react'
import './Preview.css'
import { useNavigate } from "react-router-dom";
import $ from 'jquery';
import axios from 'axios';
import ImagePath from './../assets/images/avatar-3637425_640.webp';
import { environment } from '../environment/production';

function PreviewBeforeSubmit() {
    const [apiCall, setApiCall] = useState(0)
    let i=1
    let [initialization,setInitialization]=useState(1)
    let [initializationACP,setInitializationACP]=useState(1)
    let [initializationLoad,setInitializationLoad]=useState(1)
    let [datalength,setDataLength]=useState(1)
    const [createEduStatus,setCreateEduStatus]=useState('0')
    
    const [workFormdata,setWorkFormData]=useState({
      user_id:parseInt(sessionStorage.getItem("user_id")),
      date_of_initial_appointment:'',
      period_of_appointment:'',
      office_applicant_belongs:'',
      name_and_pay_of_post:'',
      last_deputation_detail:'',
      nature_of_present_employment:'',
      addtnl_dtls_about_present_employment:'',
      addtnl_dtls_about_prsnt_employer_name:'',
      addtnl_dtls_about_present_employment_other:'',
      additional_information:'',
       short_hand_typing:'',
      sc_st_category:''
  
    })
    const [personalDetails, setPersonalDetails] = useState({ data: '' })
 
  const [data,setData]=useState({
  
    data:'',
    university_name:'',
    degree:'',
    year_of_passing:'',
    marks_obtained:'',
    subject_specialization:''
  })
    const [selectBoxValue, setSelectBoxValue] = useState({
        title: '',
        category: '',
        post_applied: '',
        location_preference1: '',
        location_preference2: '',
        location_preference3: '',
        present_state: '',
        present_district: '',
        present_pincode: '',
        permanent_state: '',
        permanent_district: '',
        permanent_pincode: '',
        office_state: '',
        office_district: '',
        office_pincode: '',
      })
      const [formdata, setFormData] = useState({
        user_id: null,
        post_applied: '',
        title: '',
        first_name: '',
        middle_name: '',
        last_name: '',
        father_title: '',
        father_first_name: '',
        father_middle_name: '',
        father_last_name: '',
        date_of_birth: '',
        mobile_no: '',
        email_id: '',
        category: '',
        designation: '',
        present_address: '',
        present_state: '',
        present_district: '',
        present_pincode: '',
        permanent_address: '',
        permanent_state: '',
        permanent_district: '',
        permanent_pincode: '',
        office_address: '',
        office_state: '',
        office_district: '',
        office_pincode: '',
        location_preference1: '',
        location_preference2: '',
        location_preference3: '',
        date_of_entry_into_govt_service: '',
        date_of_retirement_from_govt_service: '',
        current_designation: '',
        current_pay_matrix: '',
        no_of_yrs_current_pay_matrix: ''
      });
      
      const options = {
        data: {
          formdata
        },
        headers: {
          'Authorization': sessionStorage.getItem("access_token")
        }
      }
    const navigate = useNavigate();
    function print() {
        window.print()
    }

    const getPersonalDetails = () => {
        axios.post(environment.apiUrl + `/Personal/getPersonalDetailsPreviewBeforeSubmit`, JSON.stringify({ user_id: parseInt(sessionStorage.getItem('user_id')) }), ({ headers: (options.headers) }))
          .then((response) => {
    
            if (response['data']['status'] == 1) {
              setPersonalDetails({ data: response['data']['data'] })
              setSelectBoxValue({
                title: response['data']['data']['title'],
                category: response['data']['data']['category'],
                post_applied: response['data']['data']['post_applied'],
                location_preference1: response['data']['data']['location_preference1'],
                location_preference2: response['data']['data']['location_preference2'],
                location_preference3: response['data']['data']['location_preference3'],
                present_state: response['data']['data']['present_state_name'],
                present_district: response['data']['data']['present_district'],
                present_pincode: response['data']['data']['present_pincode'],
                permanent_state: response['data']['data']['permanent_state_name'],
                permanent_district: response['data']['data']['permanent_district'],
                permanent_pincode: response['data']['data']['permanent_pincode'],
                office_state: response['data']['data']['office_state_name'],
                office_district: response['data']['data']['office_district'],
                office_pincode: response['data']['data']['office_pincode']
              })
            }
    
          })
    
      }
      const getEducationQualification=()=>{
    
        axios.post(environment.apiUrl+"/Education/getEducationDetails",JSON.stringify({user_id:parseInt(sessionStorage.getItem("user_id"))}),{headers:(options.headers)})
        .then((response)=>{
         
          if(response['data']['status']==1){
            setInitialization(initialization+response.data.data.length)
            setCreateEduStatus('1')
           
            setData({
              ...data,data:response['data']
            })
           
              if(createEduStatus=='0'){
              
                $('.show_table').append('<table>'+
                '<thead>'+
                '<tr>'+
                '<th scope="col">S.No.</th>'+
                '<th colspan="2" scope="col">Name of University/<br/>Equivalent Institute</th>'+
                '<th scope="col">Degree</th>'+
                '<th scope="col">Year of<br/> Passing</th>'+
                '<th scope="col">Division/% of <br/>marks obtained</th>'+
                '<th colspan="2" scope="col">Subject/<br/>Specialization</th>'+
                '</tr>'+
                '</thead>'+
              '</table>')
             
              }
              
             // if(formdata.university_name!=='' && formdata.degree!=='' && formdata.year_of_passing!=='' && formdata.marks_obtained!=='' && formdata.subject_specialization!==''){
              for(let i=0;i<response.data.data.length;i++){
                setDataLength(i)
                $('.show_table').append('<table>'+
                '<tbody>'+
                '<tr id="row_'+i+'">'+
                '<th scope="row">'+ initialization++ +'</th>'+
                '<td colspan="2" style='+'"'+'white-space:'+'pre-wrap'+';'+'overflow-wrap:' +'break-word'+'"'+'>'+response.data.data[i]['university_name']+'</td>'+
                 '<td style='+'"'+'white-space:'+'pre-wrap'+';'+'overflow-wrap:' +'break-word'+'"'+'>'+response.data.data[i]['degree']+'</td>'+
                 '<td style='+'"'+'white-space:'+'pre-wrap'+';'+'overflow-wrap:' +'break-word'+'"'+'>'+response.data.data[i]['year_of_passing']+'</td>'+
                 '<td style='+'"'+'white-space:'+'pre-wrap'+';'+'overflow-wrap:' +'break-word'+'"'+'>'+response.data.data[i]['marks_obtained']+'</td>'+
                 '<td colspan="2" style='+'"'+'white-space:'+'pre-wrap'+';'+'overflow-wrap:' +'break-word'+'"'+'>'+response.data.data[i]['subject_specialization']+'</td>'+
               
                '</tr>'+
                '</tbody>'+
                '</table>')
               
            }
        //  }
           
          }
        })
      }
      function getExperienceDetails(){
        axios.post(environment.apiUrl+"/Experience/getExperienceDetails",JSON.stringify({user_id:sessionStorage.getItem("user_id")}),{headers:options.headers})
        .then((response)=>{
          if(response.data.status==1){
            setWorkFormData({
              date_of_initial_appointment:response.data.data['date_of_initial_appointment'],
              period_of_appointment:response.data.data['period_of_appointment'],
              office_applicant_belongs:response.data.data['office_applicant_belongs'],
              name_and_pay_of_post:response.data.data['name_and_pay_of_post'],
              last_deputation_detail:response.data.data['last_deputation_detail'],
              nature_of_present_employment:response.data.data['nature_of_present_employment'],
              addtnl_dtls_about_present_employment:response.data.data['addtnl_dtls_about_present_employment'],
              addtnl_dtls_about_prsnt_employer_name:response.data.data['addtnl_dtls_about_prsnt_employer_name'],
              addtnl_dtls_about_present_employment_other:response.data.data['addtnl_dtls_about_present_employment_other'],
              additional_information:response.data.data['additional_information'],
              short_hand_typing:response.data.data['short_hand_typing'],
              sc_st_category:response.data.data['sc_st_category']
            })
          }
        })
    }
    
const getACPDetailsEmployment=()=>{
    
    axios.post(environment.apiUrl+"/Experience/getACPDetailsEmployment",JSON.stringify({user_id:parseInt(sessionStorage.getItem("user_id"))}),{headers:(options.headers)})
    .then((response)=>{
     
      if(response['data']['status']==1){
        console.log("getACPDetailsEmployment")
        console.log(response.data.data[0]['id'])
        setInitializationACP(initializationACP+response.data.data.length)
        setCreateEduStatus('1')
 
        setData({
          ...data,data:response['data']
        })
       
          if(createEduStatus=='0'){
          
            $('.show_table_getACPDetailsEmployment').append('<table class="table-wrapper">'+
            '<thead>'+
            '<tr>'+
            '<th scope="col">S.No.</th>'+
            '<th scope="col">Office/ Institution</th>'+
            '<th scope="col">Pay-band and Grade Pay <br/> drawn under<br/> ACP/MACP scheme</th>'+
            '<th scope="col">From</th>'+
            '<th scope="col">To</th>'+
         
            '</tr>'+
            '</thead>'+
          '</table>')
         
          }
          
         // if(formdata.university_name!=='' && formdata.degree!=='' && formdata.year_of_passing!=='' && formdata.marks_obtained!=='' && formdata.subject_specialization!==''){
          for(let i=0;i<response.data.data.length;i++){
            setDataLength(i)
            $('.show_table_getACPDetailsEmployment').append('<table class="table-wrapper">'+
            '<tbody>'+
            '<tr id="rowacp_'+i+'">'+
            '<th scope="row">'+ initializationACP++ +'</th>'+
            '<td style='+'"'+'white-space:'+'pre-wrap'+';'+'overflow-wrap:' +'break-word'+'"'+'>'+response.data.data[i]['acp_office_name']+'</td>'+
             '<td style='+'"'+'white-space:'+'pre-wrap'+';'+'overflow-wrap:' +'break-word'+'"'+'>'+response.data.data[i]['acp_post_held']+'</td>'+
             '<td style='+'"'+'white-space:'+'pre-wrap'+';'+'overflow-wrap:' +'break-word'+'"'+'>'+response.data.data[i]['acp_from']+'</td>'+
             '<td style='+'"'+'white-space:'+'pre-wrap'+';'+'overflow-wrap:' +'break-word'+'"'+'>'+response.data.data[i]['acp_to']+'</td>'+
            
            '</tr>'+
            '</tbody>'+
            '</table>')
           
        }
    //  }
     
      }
    })
  }
  
    const getDetailsEmployment=()=>{
      
      axios.post(environment.apiUrl+"/Experience/getDetailsEmployment",JSON.stringify({user_id:parseInt(sessionStorage.getItem("user_id"))}),{headers:(options.headers)})
      .then((response)=>{
       
        if(response['data']['status']==1){
          setInitialization(initialization+response.data.data.length)
          setCreateEduStatus('1')
    
          setData({
            ...data,data:response['data']
          })
         
            if(createEduStatus=='0'){
            
              $('.show_table_getDetailsEmployment').append('<table class="table-wrapper">'+
              '<thead>'+
              '<tr>'+
              '<th scope="col">S.No.</th>'+
              '<th scope="col">Office/Organisation</th>'+
              '<th scope="col">Post held</th>'+
              '<th scope="col">From</th>'+
              '<th scope="col">To</th>'+
              '<th scope="col">Scale of Pay</th>'+
              '<th scope="col">Nature of Duties</th>'+
             
              '</tr>'+
              '</thead>'+
            '</table>')
           
            }
            
           // if(formdata.university_name!=='' && formdata.degree!=='' && formdata.year_of_passing!=='' && formdata.marks_obtained!=='' && formdata.subject_specialization!==''){
            for(let i=0;i<response.data.data.length;i++){
              setDataLength(i)
              $('.show_table_getDetailsEmployment').append('<table class="table-wrapper">'+
              '<tbody>'+
              '<tr id="row_'+i+'">'+
              '<th scope="row">'+ initialization++ +'</th>'+
              '<td style='+'"'+'white-space:'+'pre-wrap'+';'+'overflow-wrap:' +'break-word'+'"'+'>'+response.data.data[i]['office_name']+'</td>'+
               '<td style='+'"'+'white-space:'+'pre-wrap'+';'+'overflow-wrap:' +'break-word'+'"'+'>'+response.data.data[i]['post_held']+'</td>'+
               '<td style='+'"'+'white-space:'+'pre-wrap'+';'+'overflow-wrap:' +'break-word'+'"'+'>'+response.data.data[i]['employment_from']+'</td>'+
               '<td style='+'"'+'white-space:'+'pre-wrap'+';'+'overflow-wrap:' +'break-word'+'"'+'>'+response.data.data[i]['employment_to']+'</td>'+
               '<td style='+'"'+'white-space:'+'pre-wrap'+';'+'overflow-wrap:' +'break-word'+'"'+'>'+response.data.data[i]['scale_of_pay']+'</td>'+
               '<td style='+'"'+'white-space:'+'pre-wrap'+';'+'overflow-wrap:' +'break-word'+'"'+'>'+response.data.data[i]['nature_of_duties']+'</td>'+
             
              '</tr>'+
              '</tbody>'+
              '</table>')
             
          }
      //  }
          
        }
      })
    }
    
      useEffect(() => {
        if (apiCall == 0) {
          getACPDetailsEmployment()
          getPersonalDetails()
          getEducationQualification()
          getDetailsEmployment()
          getExperienceDetails()
        }
        setApiCall(1)
      }, [apiCall,getACPDetailsEmployment,getPersonalDetails,getEducationQualification,getDetailsEmployment,getExperienceDetails])
    return (
        <>
            <div className="container d-flex flex-column col col-sm justify-content-center">
                <h2 className="text-center"><u><b>Preview</b></u></h2><br /><br />
                <div className="heading">
                    <h4>Personal Details</h4>
                </div>
                
                <div className="profile d-flex flex-column justify-content-center align-items-center">
                    <div className="profile-name">
                        <h6 className="text-center">{selectBoxValue.title}. {personalDetails.data.first_name} {personalDetails.data.middle_name} {personalDetails.data.last_name}</h6>
                    </div>
                    <div className="profile-pic">
                        <img src={environment.apiUrl+"/uploads/profile/"+personalDetails.data.photo_path} alt="profile pic" height="100" width="100" />
                    </div>
                </div>
                <br/>
                <div className="preview_details">
                    <div className="user_personal_details">
                        <table className="user_personal_details table table-stripped table-responsive">
                            <thead>
                                <tr>
                                    <th scope="col">Post applied for</th>
                                    <th scope="col">Preference 1</th>
                                    <th scope="col">Preference 2</th>
                                    <th scope="col">Preference 3</th>
                                    <th scope="col">Email address</th>
                                    <th scope="col">Contact Number</th>
                                    {/* <th scope="col">Category</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{selectBoxValue.post_applied}</td>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{selectBoxValue.location_preference1}</td>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{selectBoxValue.location_preference2}</td>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{selectBoxValue.location_preference3}</td>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{personalDetails.data.email_id}</td>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{personalDetails.data.mobile_no}</td>
                                    {/* <td>{personalDetails.data.category}</td> */}
                                </tr>

                            </tbody>
                        </table>

                    </div>
                    <div className="user_personal_details">
                        <table className="user_personal_details table table-stripped table-responsive">
                            <thead>
                                <tr>

                                    <th scope="col">DOB</th>
                                    <th scope="col">Date of entry into government service</th>
                                    <th scope="col">Date of retirement as per Parent cadre rules</th>
                                    <th scope="col">Last held Designation</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{personalDetails.data.date_of_birth}</td>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{personalDetails.data.date_of_entry_into_govt_service}</td>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{personalDetails.data.date_of_retirement_from_govt_service}</td>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{personalDetails.data.current_designation}</td>


                                </tr>

                            </tbody>
                        </table>

                    </div>
                    <div className="user_personal_details">
                        <table className="user_personal_details table table-stripped table-responsive">
                            <thead>
                                <tr>
                                    <th>Present State</th>
                                    <th>Present Address</th>
                                    <th>Present District</th>
                                    
                                    <th>Present Pin Code</th>
                                    <th>Number of years in<br/> last held Level of Pay</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{personalDetails.data.present_state_name}</td>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{personalDetails.data.present_address}</td>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{personalDetails.data.present_district}</td>
                              
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{personalDetails.data.present_pincode}</td>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{personalDetails.data.no_of_yrs_current_pay_matrix}</td>
                                </tr>

                            </tbody>
                        </table>

                    </div>
                    <div className="user_personal_details">
                        <table className="user_personal_details table table-stripped table-responsive">
                            <thead>
                                <tr>

                                    <th>Permanent Address</th>
                                    <th>Permanent District</th>
                                    <th>Permanent State</th>
                                    <th>Permanent Pin Code</th>
                                    
                                </tr>
                            </thead>
                            <tbody>
                                <tr>

                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{personalDetails.data.permanent_address}</td>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{personalDetails.data.permanent_district}</td>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{personalDetails.data.permanent_state_name}</td>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{personalDetails.data.permanent_pincode}</td>
                                   
                                </tr>

                            </tbody>
                        </table>

                    </div>
                    <div className="user_personal_details">
                        <table className="user_personal_details table table-stripped table-responsive">
                            <thead>
                                <tr>
                                <th>Office Address</th>
                                <th>Office District</th>
                                    <th>Office State</th>
                                    <th>Office Pin Code</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{personalDetails.data.office_address}</td>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{personalDetails.data.office_district}</td>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}} >{personalDetails.data.office_state_name}</td>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{personalDetails.data.office_pincode}</td>
                                </tr>

                            </tbody>
                        </table>

                    </div>
                    {/* Education Qualification */}
                    <div className="heading">
                    <h4>Education Qualification</h4>
                    </div>
                    <br/><br/>
                   <div className="show_table table table-stripped table-responsive">

                   </div>
                   <div className="heading">
                        <h4>Work Experience</h4>
                   </div>
                   <br/><br/>
                   <div className="show_table_getACPDetailsEmployment table table-stripped table-responsive">

                   </div>
                   <br/><br/>
                   <div className="show_table_getDetailsEmployment table table-stripped table-responsive">

                   </div>
                    <br/><br/>
                   <div className="work_experience">
                        <table className="work_experience table table-stripped table-responsive">
                            <thead>
                                <tr>
                                    <th scope="col">Nature of last employment</th>
                                    <th scope="col">Date of initial appointment</th>
                                    <th scope="col">Period of appointment on <br/>deputation/contract</th>
                                    <th scope="col">Name of the Parent office/<br/>organisation to which the<br/> applicant belonged</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{workFormdata.nature_of_present_employment}</td>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{workFormdata.date_of_initial_appointment}</td>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{workFormdata.period_of_appointment}</td>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{workFormdata.office_applicant_belongs}</td>
                                </tr>

                            </tbody>
                        </table>

                    </div>
                    <div className="work_experience">
                        <table className="work_experience table table-stripped table-responsive">
                        <thead>
                        <tr>
                       
                                    <th scope="col">Additional details<br/> about last employment </th>
                                    <th scope="col">Additional information</th>
                          </tr>
                          </thead>
                          <tbody>
                              <tr>
                              
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{workFormdata.addtnl_dtls_about_prsnt_employer_name}</td>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{workFormdata.additional_information}</td>
                              </tr>
                          </tbody>
                        </table>
                    </div>
                    <div className="work_experience">
                        <table className="work_experience table table-stripped table-responsive">
                            <thead>
                                <tr>

                                <th scope="col">If any post held on deputation<br/> in the past by the applicant,<br/> date of return from the last<br/> deputation and other details</th>
                                    <th scope="col">Additional details about present<br/> employment</th>
                                    <th scope="col">Shorthand & Typing Speed</th>
                                    <th scope="col">Whether belongs to SC/ ST</th>
                                    <th scope="col">Name of the post and Pay of<br/> the post held in substantive<br/> capacity in the parent</th>
                                   
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{workFormdata.last_deputation_detail}</td>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{workFormdata.addtnl_dtls_about_present_employment}</td>

                                    <td>{workFormdata.short_hand_typing}</td>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{workFormdata.sc_st_category}</td>
                                    <td style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{workFormdata.name_and_pay_of_post}</td>
                                    

                                </tr>

                            </tbody>
                        </table>

                    </div>
                    
                </div>
                <hr />
            </div>
            <div className="button">
                <button className="btn btn-dark" onClick={print}>Print</button>
            </div>
            <br /> <br />
        </>
    )
}

export default PreviewBeforeSubmit